(() => {
  'use strict';
  if (window.__tmProductFilmSections) {
    window.__tmProductFilmSections.mountWithin(document);
    return;
  }
  const instances = new Map();
  function mount(dialog) {
    if (instances.has(dialog)) return;
    const root = dialog.closest('.pdp-films');
    const video = dialog.querySelector('video');
    const closeButton = dialog.querySelector('[data-pdp-film-close]');
    if (!root || !video || !closeButton) return;
    const events = new AbortController();
    const listen = (target, type, listener, options = {}) => target.addEventListener(type, listener, {...options, signal: events.signal});
    const narrow = matchMedia('(max-width:1000px)');
    const links = [...root.querySelectorAll('[data-pdp-film]')];
    const inlinePlayers = new Map();
    const visibility = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) entry.target.pause();
    }));
    let opener, pending;
    const cancelPending = () => { pending?.abort(); pending = null; };
    const pauseInline = except => inlinePlayers.forEach(player => { if (player !== except) player.pause(); });
    const pause = () => { cancelPending(); pauseInline(); video.pause(); };
    const syncLinks = () => {
      inlinePlayers.forEach((player, card) => {
        player.hidden = !narrow.matches;
        const trigger = card.querySelector('.pdp-film-trigger');
        if (trigger) trigger.hidden = narrow.matches;
      });
      links.forEach(link => {
        if (narrow.matches) {
          link.removeAttribute('aria-haspopup');
          const player = inlinePlayers.get(link.closest('.pdp-film'));
          if (player) link.setAttribute('aria-controls', player.id); else link.removeAttribute('aria-controls');
        } else {
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', dialog.id);
        }
      });
    };
    function playInline(link) {
      const card = link.closest('.pdp-film');
      const frame = card?.querySelector('.pdp-film-frame');
      if (!frame) return;
      let player = inlinePlayers.get(card);
      if (!player) {
        player = document.createElement('video');
        const sectionId = root.closest('.shopify-section')?.id || 'product';
        player.id = 'PdpInlineFilm-' + sectionId + '-' + (inlinePlayers.size + 1);
        player.className = 'pdp-inline-video';
        player.controls = true;
        player.playsInline = true;
        player.preload = 'none';
        player.poster = frame.querySelector('img')?.currentSrc || '';
        player.setAttribute('aria-label', link.dataset.filmTitle);
        const start = Number(link.dataset.filmStart) || 0;
        listen(player, 'loadedmetadata', () => { player.currentTime = start; }, {once: true});
        player.src = link.href;
        listen(player, 'play', () => { pauseInline(player); video.pause(); });
        frame.querySelector('.pdp-film-trigger').hidden = true;
        frame.append(player);
        inlinePlayers.set(card, player);
        visibility.observe(player);
        syncLinks();
      }
      pauseInline(player);
      if (player.ended) player.currentTime = Number(link.dataset.filmStart) || 0;
      player.focus({preventScroll: true});
      player.play().catch(() => {});
    }
    links.forEach(link => listen(link, 'click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (narrow.matches) {
        event.preventDefault();
        playInline(link);
        return;
      }
      if (!dialog.showModal) return;
      event.preventDefault();
      pauseInline();
      cancelPending();
      opener = link;
      const request = pending = new AbortController();
      dialog.querySelector('#PdpFilmTitle').textContent = link.dataset.filmTitle;
      const begin = () => {
        if (request.signal.aborted || events.signal.aborted || !dialog.open) return;
        video.currentTime = Number(link.dataset.filmStart) || 0;
        video.play().catch(() => {});
      };
      const source = link.href.split('#')[0];
      if (video.src !== source) {
        video.src = source;
        video.poster = link.closest('.pdp-film').querySelector('img')?.currentSrc || '';
        video.load();
      }
      dialog.showModal();
      closeButton.focus({preventScroll: true});
      if (video.readyState >= 1) begin(); else {
        video.addEventListener('loadedmetadata', begin, {once: true, signal: request.signal});
        video.load();
      }
    }));
    listen(closeButton, 'click', () => dialog.close());
    listen(dialog, 'close', () => { cancelPending(); video.pause(); if (opener?.isConnected) opener.focus({preventScroll: true}); });
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    listen(narrow, 'change', () => { pauseInline(); if (dialog.open) dialog.close(); syncLinks(); });
    listen(document, 'visibilitychange', () => { if (document.hidden) pause(); });
    listen(window, 'pagehide', pause);
    instances.set(dialog, {
      sync: syncLinks,
      destroy() {
        pause();
        events.abort();
        visibility.disconnect();
        opener = null;
        if (dialog.open) dialog.close();
        inlinePlayers.forEach((player, card) => {
          player.removeAttribute('src');
          player.load();
          player.remove();
          const trigger = card.querySelector('.pdp-film-trigger');
          if (trigger) trigger.hidden = false;
        });
        inlinePlayers.clear();
        video.removeAttribute('src');
        video.load();
        instances.delete(dialog);
      }
    });
    syncLinks();
  }
  function mountWithin(parent) {
    if (parent.matches?.('[data-pdp-film-dialog]')) mount(parent);
    parent.querySelectorAll('[data-pdp-film-dialog]').forEach(mount);
  }
  window.__tmProductFilmSections = {mountWithin};
  mountWithin(document);
  document.addEventListener('shopify:section:load', event => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [dialog, instance] of instances) if (event.target === dialog || event.target.contains(dialog)) instance.destroy();
  });
  document.addEventListener('shopify:section:reorder', () => instances.forEach(instance => instance.sync()));
})();
